var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticClass:"card-area",attrs:{"bordered":false}},[_vm._v(" 百科评论 "),_c('common-table',{ref:"table",attrs:{"path":"newsComment","columns":_vm.columns},scopedSlots:_vm._u([{key:"operation",fn:function(ref){
var record = ref.record;
return [_c('action-delete',{on:{"click":function($event){return _vm.remove(record)}}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }